import React from 'react'
import { Route, Routes } from 'react-router-dom'
import NotFoundPage from '../pages/error/404'
import { Row, Col } from 'react-bootstrap'
import Dashboard from '../pages/parent/Dashboard'
import FollowUp from '../pages/parent/FollowUp'
import Profile from '../pages/student/Profile'
import Academic from '../pages/student/Academic'
import Administration from '../pages/student/Administration'
import Communications from '../pages/student/Communications'
import ChangePassword from '../pages/auth/ChangePassword'
import Version from '../version'
import Menu from '../components/menus/Menu'
import Sidebar from '../components/menus/Sidebar'

export default function ParentRouter() {

	return (
		<div className='contenido'>
			<Sidebar />
			<div className='content'>
				<Menu />
				<Routes>
					<Route path="/dashboard" element={<Dashboard />} />
					<Route path="/follow-up" element={<FollowUp />} />
					<Route path="/profile" element={<Profile />} />
					<Route path="/academic" element={<Academic />} />
					<Route path="/administration" element={<Administration />} />
					<Route path="/communications" element={<Communications />} />
					<Route path="/change-password" element={<ChangePassword />} />
					<Route path="*" element={<NotFoundPage />} />
				</Routes>
				<Row>
					<Col className='text-center my-3'>
						<Version />
					</Col>
				</Row>
			</div>
		</div>
	)
}
